<template>
  <div class="contact-page">
    <!-- Hero Section -->
    <section class="page-hero">
      <div class="hero-overlay"></div>
      <div class="container">
        <div class="hero-content" data-aos="fade-up">
          <h1 class="page-title">Get In Touch</h1>
          <p class="page-subtitle">We'd love to hear from you. Send us a message and we'll respond as soon as possible.</p>
        </div>
      </div>
    </section>

    <!-- Contact Info + Form Section -->
    <section class="contact-main">
      <div class="container">
        <div class="row g-5">
          <!-- Contact Information -->
          <div class="col-lg-5" data-aos="fade-right">
            <div class="contact-info-wrapper">
              <div class="section-header text-start">
                <span class="section-subtitle">Contact Information</span>
                <h2 class="section-title-modern">Let's Connect</h2>
                <div class="title-underline ms-0"></div>
              </div>
              
              <div class="contact-info-list">
                <div class="info-item">
                  <div class="info-icon">
                    <i class="fas fa-map-marker-alt"></i>
                  </div>
                  <div class="info-content">
                    <h4 class="info-title">Visit Us</h4>
                    <p class="info-text">https://beesatelier.art/</p>
                  </div>
                </div>
                
                <!--<div class="info-item">
                  <div class="info-icon">
                    <i class="fas fa-phone-alt"></i>
                  </div>
                  <div class="info-content">
                    <h4 class="info-title">Call Us</h4>
                    <p class="info-text">+91 98765 43210<br>Mon-Sat: 10AM - 7PM</p>
                  </div>
                </div>-->
                
                <!-- Email info-item -->
                <div class="info-item">
                  <div class="info-icon"><i class="fas fa-envelope"></i></div>
                  <div class="info-content">
                    <h4 class="info-title">Email Us</h4>
                    <p class="info-text">{{ settings.contact_email || 'beesatelier24@gmail.com' }}</p>
                  </div>
                </div>

                <!-- Address info-item (show only if set) -->
                <div class="info-item" v-if="settings.contact_address">
                  <div class="info-icon"><i class="fas fa-map-marker-alt"></i></div>
                  <div class="info-content">
                    <h4 class="info-title">Address</h4>
                    <p class="info-text">{{ settings.contact_address }}</p>
                  </div>
                </div>

                <!-- Phone info-item (show only if set) -->
                <div class="info-item" v-if="settings.contact_phone">
                  <div class="info-icon"><i class="fas fa-phone-alt"></i></div>
                  <div class="info-content">
                    <h4 class="info-title">Call Us</h4>
                    <p class="info-text">{{ settings.contact_phone }}</p>
                  </div>
                </div>

              </div>
              
              <div class="social-links">
                <h4 class="social-title">Follow Us</h4>
                <!-- Social icons — replace static hrefs -->
                <div class="social-icons">
                  <a v-if="settings.social_instagram" :href="settings.social_instagram" class="social-icon" target="_blank">
                    <i class="fab fa-instagram"></i>
                  </a>
                  <a v-if="settings.social_facebook" :href="settings.social_facebook" class="social-icon" target="_blank">
                    <i class="fab fa-facebook"></i>
                  </a>
                  <a v-if="settings.social_pinterest" :href="settings.social_pinterest" class="social-icon" target="_blank">
                    <i class="fab fa-pinterest"></i>
                  </a>
                  <a v-if="settings.social_twitter" :href="settings.social_twitter" class="social-icon" target="_blank">
                    <i class="fab fa-twitter"></i>
                  </a>
                  <a v-if="settings.social_whatsapp" :href="'https://wa.me/' + settings.social_whatsapp" class="social-icon" target="_blank">
                    <i class="fab fa-whatsapp"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Contact Form -->
          <div class="col-lg-7" data-aos="fade-left">
            <div class="contact-form-wrapper">
              <form @submit.prevent="submitForm" class="contact-form">
                <div class="row g-4">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form-label">Your Name *</label>
                      <input 
                        type="text" 
                        class="form-control" 
                        v-model="formData.name"
                        placeholder="Enter your name"
                        required
                      >
                    </div>
                  </div>
                  
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form-label">Email Address *</label>
                      <input 
                        type="email" 
                        class="form-control" 
                        v-model="formData.email"
                        placeholder="your@email.com"
                        required
                      >
                    </div>
                  </div>
                  
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form-label">Phone Number</label>
                      <input 
                        type="tel" 
                        class="form-control" 
                        v-model="formData.phone"
                        placeholder="+91 98765 43210"
                      >
                    </div>
                  </div>
                  
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form-label">Subject</label>
                      <select class="form-control" v-model="formData.subject">
                        <option value="">Select a subject</option>
                        <option value="general">General Inquiry</option>
                        <option value="order">Order Question</option>
                        <option value="workshop">Workshop Information</option>
                        <option value="custom">Custom Order</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                  </div>
                  
                  <div class="col-12">
                    <div class="form-group">
                      <label class="form-label">Message *</label>
                      <textarea 
                        class="form-control" 
                        v-model="formData.message"
                        placeholder="Tell us more about your inquiry..."
                        rows="6"
                        required
                      ></textarea>
                    </div>
                  </div>
                  
                  <div class="col-12">
                    <button type="submit" class="btn-submit" :disabled="isSubmitting">
                      <span v-if="!isSubmitting">
                        <i class="fas fa-paper-plane"></i>
                        Send Message
                      </span>
                      <span v-else>
                        <i class="fas fa-spinner fa-spin"></i>
                        Sending...
                      </span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Map Section -->
    <!--<section class="map-section">
      <div class="container">
        <div class="map-wrapper" data-aos="fade-up">
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.9907081605785!2d72.55969931496324!3d23.02579012174859!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e848aba5bd449%3A0x4fcedd11614f6516!2sAhmedabad%2C%20Gujarat!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin"
            width="100%" 
            height="450" 
            style="border:0; border-radius: 20px;" 
            allowfullscreen="" 
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </section>-->

    <!-- FAQ Quick Links -->
    <section class="quick-links">
      <div class="container">
        <div class="section-header">
          <span class="section-subtitle">Need Help?</span>
          <h2 class="section-title-modern">Frequently Asked Questions</h2>
          <div class="title-underline"></div>
        </div>
        
        <div class="row g-4">
          <div class="col-md-4" data-aos="fade-up" data-aos-delay="0">
            <div class="quick-link-card">
              <i class="fas fa-shipping-fast"></i>
              <h4>Shipping Info</h4>
              <p>Learn about our shipping policies and delivery times.</p>
              <a href="/shipping-returns" class="link-arrow">Learn More <i class="fas fa-arrow-right"></i></a>
            </div>
          </div>
          
          <div class="col-md-4" data-aos="fade-up" data-aos-delay="100">
            <div class="quick-link-card">
              <i class="fas fa-undo-alt"></i>
              <h4>Returns</h4>
              <p>Our hassle-free return and exchange policy.</p>
              <a href="/shipping-returns#returns" class="link-arrow">Learn More <i class="fas fa-arrow-right"></i></a>
            </div>
          </div>
          
          <div class="col-md-4" data-aos="fade-up" data-aos-delay="200">
            <div class="quick-link-card">
              <i class="fas fa-question-circle"></i>
              <h4>FAQ</h4>
              <p>Find answers to commonly asked questions.</p>
              <a href="/faq" class="link-arrow">View All <i class="fas fa-arrow-right"></i></a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { useToast } from 'vue-toast-notification';
import SettingsService from '../services/SettingsService';


export default {
  name: 'ContactPage',
  data() {
    return {
      settings: {},
      formData: {
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      },
      isSubmitting: false
    }
  },
  methods: {
    loadSettings() {
      SettingsService.getPublicSettings()
        .then((response) => {
          this.settings = response.data.data;
        })
        .catch(() => {});
    },
    async submitForm() {
      const $toast = useToast();
      
      this.isSubmitting = true;
      
      // Simulate form submission
      setTimeout(() => {
        $toast.success('Thank you! Your message has been sent successfully.');
        
        // Reset form
        this.formData = {
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: ''
        };
        
        this.isSubmitting = false;
      }, 1500);
    }
  },
  mounted() {
    this.loadSettings();
    if (typeof AOS !== 'undefined') {
      AOS.init({
        duration: 800,
        easing: 'ease-in-out',
        once: true,
        offset: 100
      });
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=Playfair+Display:wght@400;500;600;700&display=swap');

.contact-page {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* ========== HERO SECTION ========== */
.page-hero {
  height: 300px;
  background: linear-gradient(135deg, rgba(118, 172, 175, 0.9), rgba(98, 152, 155, 0.9));
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-top: 80px;
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.2);
}

.hero-content {
  text-align: center;
  color: white;
  position: relative;
  z-index: 2;
}

.page-title {
  font-family: 'Playfair Display', serif;
  font-size: clamp(2.5rem, 5vw, 4rem);
  font-weight: 700;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
}

.page-subtitle {
  font-size: clamp(1rem, 2vw, 1.3rem);
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.3);
}

/* ========== CONTACT MAIN SECTION ========== */
.contact-main {
  padding: 10px 0;
  background: white;
}

.section-header {
  margin-bottom: 30px;
}

.section-subtitle {
  color: rgb(118, 172, 175);
  font-weight: 600;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 2px;
  display: block;
  margin-bottom: 10px;
}

.section-title-modern {
  font-family: 'Playfair Display', serif;
  font-size: clamp(2rem, 4vw, 2rem);
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 5px;
}

.title-underline {
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, rgb(118, 172, 175), rgb(98, 152, 155));
  margin: 0 auto;
  border-radius: 2px;
}

/* Contact Info */
.contact-info-wrapper {
  background: #f8fafb;
  padding: 40px;
  border-radius: 20px;
  height: 100%;
}

.contact-info-list {
  margin: 40px 0;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.info-item {
  display: flex;
  gap: 20px;
}

.info-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, rgb(118, 172, 175), rgb(98, 152, 155));
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.info-icon i {
  color: white;
  font-size: 1.3rem;
}

.info-content {
  flex: 1;
  text-align: left;
}

.info-title {
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 5px;
  font-size: 1rem;
}

.info-text {
  color: #718096;
  line-height: 1.7;
  margin: 0;
}

.social-links {
  margin-top: 40px;
  padding-top: 30px;
  border-top: 2px solid #e2e8f0;
}

.social-title {
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 15px;
}

.social-icons {
  display: flex;
  gap: 15px;
  justify-content: center;
  padding-bottom: 5px;
}

.social-icon {
  width: 45px;
  height: 45px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(118, 172, 175);
  transition: all 0.3s;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.social-icon:hover {
  background: rgb(118, 172, 175);
  color: white;
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(118, 172, 175, 0.4);
}

/* Contact Form */
.contact-form-wrapper {
  background: white;
  padding: 40px;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
}

.form-group {
  margin-bottom: 0;
}

.form-label {
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 8px;
  display: block;
  font-size: 0.95rem;
  text-align: left;
}

.form-control {
  width: 100%;
  padding: 12px 18px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 1rem;
  transition: all 0.3s;
  font-family: 'Inter', sans-serif;
}

.form-control:focus {
  outline: none;
  border-color: rgb(118, 172, 175);
  box-shadow: 0 0 0 3px rgba(118, 172, 175, 0.1);
}

textarea.form-control {
  resize: vertical;
  min-height: 150px;
}

.btn-submit {
  width: 100%;
  padding: 16px;
  background: linear-gradient(135deg, rgb(118, 172, 175), rgb(98, 152, 155));
  color: white;
  border: none;
  border-radius: 50px;
  font-weight: 600;
  font-size: 1.05rem;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.btn-submit:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(118, 172, 175, 0.4);
}

.btn-submit:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* ========== MAP SECTION ========== */
.map-section {
  padding: 0 0 100px 0;
  background: white;
}

.map-wrapper {
  box-shadow: 0 10px 40px rgba(0,0,0,0.15);
  border-radius: 20px;
  overflow: hidden;
}

/* ========== QUICK LINKS SECTION ========== */
.quick-links {
  padding: 100px 0;
  background: #f8fafb;
}

.quick-link-card {
  background: white;
  padding: 40px 30px;
  border-radius: 20px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  transition: all 0.4s;
}

.quick-link-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 40px rgba(0,0,0,0.15);
}

.quick-link-card i {
  font-size: 3rem;
  color: rgb(118, 172, 175);
  margin-bottom: 20px;
}

.quick-link-card h4 {
  font-family: 'Playfair Display', serif;
  font-size: 1.5rem;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 15px;
}

.quick-link-card p {
  color: #718096;
  line-height: 1.7;
  margin-bottom: 20px;
}

.link-arrow {
  color: rgb(118, 172, 175);
  font-weight: 600;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s;
}

.link-arrow:hover {
  gap: 12px;
  color: rgb(98, 152, 155);
}

/* ========== MOBILE RESPONSIVE ========== */
@media (max-width: 768px) {
  .page-hero {
    height: 300px;
    margin-top: 70px;
  }
  
  .contact-main,
  .quick-links {
    padding: 10px 0;
  }
  
  .map-section {
    padding: 0 0 60px 0;
  }
  
  .contact-info-wrapper,
  .contact-form-wrapper {
    padding: 30px 20px;
  }
  
  .map-wrapper iframe {
    height: 300px;
  }
}
</style>